import React from 'react'

export type StickyActionBarProps = React.PropsWithChildren<{
  className?: string
  style?: React.CSSProperties
  /** Set to false when nesting inside an already-sticky ancestor. */
  sticky?: boolean
}>

const baseStyle: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 25,
  display: 'flex',
  gap: 10,
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: '10px 14px',
  marginBottom: 16,
  background: '#ffffff',
  border: '1px solid #e5e7eb',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)',
  boxSizing: 'border-box'
}

export default function StickyActionBar({ children, className, style, sticky = true }: StickyActionBarProps) {
  const resolvedStyle: React.CSSProperties = sticky
    ? { ...baseStyle, ...style }
    : { ...baseStyle, position: 'static', ...style }

  return (
    <div className={className} style={resolvedStyle}>
      {children}
    </div>
  )
}
